import { axios } from '~/clients';
import { GET_OWNER_REVIEWS } from '~/constants/endpoints';
import type { OwnerReviewsResponse } from '~/services/vdp/contracts';

export default function fetchVehicleRating(
  payload: {
    make: string;
    model: string;
    trim: string;
    year: number;
  },
  controller: AbortController
) {
  return axios.post<OwnerReviewsResponse>(
    GET_OWNER_REVIEWS,
    { size: 1, ...payload },
    {
      signal: controller.signal
    }
  );
}
